import React from 'react';
import './DesktopIcon.css';

interface DesktopIconProps {
  name: string;
  icon: string;
  onDoubleClick: () => void;
  onSingleClick: () => void;
  isSelected: boolean;
  position: { x: number; y: number };
  paintInDelay?: number;
  isEmoji?: boolean;
}

const DesktopIcon: React.FC<DesktopIconProps> = ({ name, icon, onDoubleClick, onSingleClick, isSelected, position, paintInDelay = 0, isEmoji = false }) => {
  // Detect if device supports touch
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    // On touch devices, highlight AND open
    if (isTouchDevice) {
      onSingleClick(); // Highlight it
      onDoubleClick(); // Then open it
    } else {
      onSingleClick();
    }
  };

  const renderIcon = () => {
    if (isEmoji) {
      return (
        <span className={`desktop-icon-emoji ${isSelected ? 'selected' : ''}`}>
          {icon}
        </span>
      );
    }
    if (typeof icon === 'string' && (icon.startsWith('/') || icon.startsWith('data:') || icon.includes('static'))) {
      return (
        <img 
          src={icon} 
          alt={name}
          className={`desktop-icon-img ${isSelected ? 'selected' : ''}`}
        />
      );
    }
    return <span className={isSelected ? 'selected' : ''}>{icon}</span>;
  };

  return (
    <div
      className="desktop-icon paint-in-icon"
      style={{
        left: position.x,
        top: position.y,
        animationDelay: `${paintInDelay + 300}ms` // 300ms base delay for background + menubar
      }}
      onClick={handleClick}
      onDoubleClick={onDoubleClick}
    >
      <div className="desktop-icon-image">
        {renderIcon()}
      </div>
      <div className={`desktop-icon-label ${isSelected ? 'selected' : ''}`}>
        {name}
      </div>
    </div>
  );
};

export default DesktopIcon;